// extracted by mini-css-extract-plugin
module.exports = {"newLine":"_2b2c827"};